<mat-card>
  <mat-card-title>Material Cost Estimation</mat-card-title>
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" class="mat-table" multiTemplateDataRows>

      <!-- Material -->
      <ng-container matColumnDef="material">
        <th mat-header-cell *matHeaderCellDef> Material </th>
        <td mat-cell *matCellDef="let element"> {{ element.material }} </td>
      </ng-container>

      <!-- Specifications -->
      <ng-container matColumnDef="specifications">
        <th mat-header-cell *matHeaderCellDef> Specifications </th>
        <td mat-cell *matCellDef="let element"> {{ element.specifications }} </td>
      </ng-container>

      <!-- Quantity -->
      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef> Quantity </th>
        <td mat-cell *matCellDef="let element"> {{ element.quantity | number }} </td>
      </ng-container>

      <!-- Unit -->
      <ng-container matColumnDef="unit">
        <th mat-header-cell *matHeaderCellDef> Unit </th>
        <td mat-cell *matCellDef="let element"> {{ element.unit }} </td>
      </ng-container>

      <!-- Per KG Rate -->
      <ng-container matColumnDef="perKgRate">
        <th mat-header-cell *matHeaderCellDef> Per KG Rate (₹) </th>
        <td mat-cell *matCellDef="let element"> ₹{{ element.perKgRate.toFixed(2) }} </td>
      </ng-container>

      <!-- Total Cost -->
      <ng-container matColumnDef="totalCost">
        <th mat-header-cell *matHeaderCellDef> Total Cost (₹) </th>
        <td mat-cell *matCellDef="let element"> ₹{{ element.totalCost | number }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</mat-card>

